import { ShieldCheck } from "@phosphor-icons/react";

import { HookObject, ListItemsHooks } from "@/plugins/types";
import { Accounts } from "./Accounts";
import { AdminBanner } from "./AdminBanner";

// ADM-2 — the staff-only Admin screen. Only accounts with the "admin" permission see the menu
// item or the route; the server checks admin again on every call.
export const onListItems = (hook: HookObject, _: unknown, __: unknown, { permissions = [] as string[] }) => {
  if (hook.id === ListItemsHooks.APP_DRAWER && hook.position === "top") {
    if (!permissions.includes("admin")) return [];
    return [
      {
        label: "Admin",
        icon: <ShieldCheck className="text-lg" />,
        href: "/admin",
        order: 99,
      },
    ];
  }

  if (hook.id === ListItemsHooks.ROUTES) {
    if (!permissions.includes("admin")) return [];
    return [{ path: "/admin", element: <Accounts /> }];
  }
};

export { Accounts, AdminBanner };
